import React, { memo, useEffect, useMemo, useState } from "react";
import ReactDOM from "react-dom";
import { Box, Button, Fab, Divider, IconButton, List, ListItem, ListItemButton, Paper, TextField, Typography } from '@mui/material';
import { Add, MoreVert } from '@mui/icons-material'
import GridLayout, { WidthProvider } from "react-grid-layout";
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import { ApolloClient, ApolloProvider, gql, InMemoryCache, useMutation } from "@apollo/client";
import { InnerComponent } from "./inner-component";
import { ElementModal } from "./modal";
import { nanoid } from "nanoid";
import { ViewModal } from "./view-modal";
import { RightClickMenu } from "./right-click-menu";
import { Sidebar } from "./sidebar";

console.log({ApolloClient})

const IGridLayout : any = GridLayout;

const client = new ApolloClient({
  uri: localStorage.getItem('HEXHIVE_API') || 'http://localhost:7030/graphql',
  credentials: 'include',
  cache: new InMemoryCache()
})

export default function Root(props){
  return (
    <ApolloProvider client={client}>
      <RootWrapped {...props} />
    </ApolloProvider>
  )
}

export interface RootProps {
  
  modules?: any[];
  getElements?: () => Promise<any[]>;

  getModule?: (module: string) => any;

  deleteSubView?: (item: any) => Promise<void>;
  updateSubView?: (item: any) => Promise<void>;
  createSubView?: (item: any) => Promise<void>;

  getView?: () => Promise<any>;

  updateView?: (view: string, layout: any) => Promise<void>;

  // rootView?: {name: string, subviews?: any[]};

}

 const RootWrapped : React.FC<RootProps> = (props) => {

  const ResponsiveReactGridLayout = useMemo(() => WidthProvider(IGridLayout) as any, []);

  const [ editMenuItem, setEditMenuItem ] = useState<any>(null);

  const [ elements, setElements ] = useState<any[]>([]);

  const [ modalOpen, openModal ] = useState(false);

  const [ selected, setSelected ] = useState<any>(null)
  const [ selectedElement, setSelectedElement ] = useState<any>(null)

  const [ rootView, setRootView ] = useState<any>(null)

  useEffect(() => {

    props.getView?.().then((data) => setRootView(data))
    props.getElements?.().then((elements) => setElements(elements))

  }, [props.getView, props.getElements]);
  
  const reduceSubview = (prev: any, curr) => {
    return prev.concat([curr, ...(curr.subviews || []).reduce(reduceSubview, [])])
  }

  const subviews = rootView?.subviews || []; 

  const getChildren = (item: any) => {
    let children = subviews.filter((a) => a.parent?.id == item.id);
    return {
      ...item,
      subviews: children.map(getChildren)
    }
  }

  const sorted_views = subviews.filter((a) => a.parent == null)?.map(getChildren)

  const allSubviews = (rootView?.subviews || []).reduce(reduceSubview, []) || [];

  const addView = () => {
    setEditMenuItem({});
  }

  const addToGrid = () => {
    openModal(true)
  }

  const selectedSubview = allSubviews.find((a) => a.id == selected?.id) || {};
  
  const [ modules, setModules ] = useState<any>({});

  const [ rightClickPoint, setRightClickPoint ] = useState<any>(null);

  useEffect(() => {
    (async () => {
      const elements : any[] = [...new Set(selectedSubview?.layout?.map((x) => x.element))]
      await Promise.all((elements || []).map(async (el) => {
        // let element = elements.find((a) => a.name == el.name);
        const element = await props.getModule(el)

        setModules((m) => ({
          ...m,
          [el]: element
        }))
      }))

    })();
  }, [elements, selectedSubview])

  return <div style={{
    display: 'flex',
    padding: '8px',
    flex: 1,
    position: 'relative'
  }}>
    <ViewModal
      views={subviews}
      selected={editMenuItem}
      open={Boolean(editMenuItem)}
      onDelete={() => {
        props.deleteSubView?.(editMenuItem).then(() => {
          props.getView?.().then((data) => setRootView(data))
          setEditMenuItem(null);
        })
      }}
      onSubmit={(view) => {
        let promise: any;
        if(view.id){
          promise = props.updateSubView?.(view)
        }else{
          promise = props.createSubView?.(view)
        }
        promise.then(() => {
          props.getView?.().then((data) => setRootView(data))
          setEditMenuItem(null);
  
        });
      }}
      onClose={() => {
        setEditMenuItem(null)
      }}
      />
    <ElementModal 
      modules={props.modules}
      getModule={props.getModule}
      elements={elements}
      selected={selectedElement}
      open={modalOpen}
      onSubmit={({id, element, options}) => {

        let layout = (selectedSubview?.layout || []).slice()

        if(id){
          let ix = layout.findIndex((a) => a.id == id);
          layout[ix] = {
            ...layout[ix],
            element: element.name,
            options: options,
          }
        }else{
          layout = layout.concat([
            {
              id: nanoid(),
              x: 0,
              y: 0,
              w: 2,
              h: 2,
              options: options,
              element: element.name,
            }
          ])
        }

        props.updateView?.(selected?.id, layout).then(() => {
          props.getView?.().then((data) => setRootView(data))
          openModal(false)
          setSelectedElement(null);
        })

      }}
      onClose={() =>{
        openModal(false)
        setSelectedElement(null);
      }}
      />
      <Box sx={{minWidth: '200px'}}>
        <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
          <Typography fontWeight={"bold"}>{rootView?.name}</Typography>
          <IconButton onClick={() => addView()}>
            <Add />
          </IconButton>
        </Box>
        <Divider />
        <RightClickMenu 
            onRename={() => {
              setEditMenuItem(rightClickPoint?.selected)
            }}
            onCreateSubview={() => {
              console.log({rightClickPoint})


              setEditMenuItem({
                rootSubView: {id: rightClickPoint?.selected?.id},
              })
            }}
            point={rightClickPoint} 
            onClose={() => setRightClickPoint(null)} />
        {/* <List>
        
        {subviews?.map((menuItem, ix) => (
          <ListItem 
            onContextMenu={(e) => {
              //- ADD RIGHT CLICK
              e.preventDefault();
              setRightClickPoint({left: e.clientX, top: e.clientY, selected: menuItem})
            }}
            secondaryAction={(
              <IconButton onClick={() => {
                setEditMenuItem(menuItem)
              }} size="small">
                <MoreVert fontSize="inherit" />
              </IconButton>
            )}
            sx={{background: selected?.id == menuItem?.id ? '#dfdfdf' : undefined}} key={ix} disablePadding>
            <ListItemButton onClick={() => setSelected(menuItem)}>
            {menuItem?.name}
            </ListItemButton>
          </ListItem>
        ))}
        </List> */}
        <Sidebar 
          onSelect={(item) => {
            setSelected(item)
          }}
          onEdit={(item) => {
            setEditMenuItem(item)
          }}
          onContext={(e, item) => {
            setRightClickPoint({left: e.clientX, top: e.clientY, selected: item})
          }}
          subviews={sorted_views} />
      </Box>
      <Divider orientation="vertical" />
      <Box sx={{flex: 1, minHeight: 0, position: 'relative', overflow: 'scroll'}}>
        {!selected && <Box sx={{
          position: 'absolute',
          top: 0, left: 0, bottom: 0, right: 0,
          flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <Typography>Select a view</Typography>
        </Box>}
        {selectedSubview?.layout?.length == 0 ? (
          <Box sx={{
            position: 'absolute',
            top: 0, left: 0, bottom: 0, right: 0,
            display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <Typography>Add some elements</Typography>
          </Box>
        ) : null}
        {selected ? <Button sx={{
          position: 'absolute',
          right: '8px',
          bottom: '8px'
        }} onClick={addToGrid} variant="contained">Add</Button> : null}
        <ResponsiveReactGridLayout
          style={{flex: 1}}
          className="layout"
          onLayoutChange={(layout) => {
            let newLayout = (selectedSubview?.layout || []).slice();
            layout.forEach((item) => {

              let ix = newLayout.findIndex((a) => a.id == item.i);

              newLayout[ix] = Object.assign({}, newLayout[ix], {x: item.x, y: item.y, w: item.w, h: item.h});

            });
            
            props.updateView(selected?.id, newLayout)
          props.getView?.().then((data) => setRootView(data))

          }}
          layout={(selectedSubview?.layout || []).map((x, ix) => ({i: x.id, x: x.x, y: x.y, w: x.w || 1, h: x.h || 1}))}
          cols={12}
          rowHeight={30}
          // width={1200}
        >
          {selectedSubview?.layout?.map((layout, ix) => {
            const {mount, unmount} = props.modules?.[layout?.element] || {}; //props.getModule?.(layout.element);

            return <div style={{display: 'flex', position: 'relative', border: '1px solid black'}} key={layout.id}>
              <Fab 
                size="small"
                onMouseDown={(e) => {
                  e.stopPropagation();

                  const {id} = elements.find((a) => a.name == layout.element)
                  setSelectedElement({...layout, element: {id, name: layout.element}})
                  openModal(true);
                  
                }}
                sx={{position: 'absolute', zIndex: 99, right: 8, top: 8}}>
                <MoreVert />
              </Fab>
              <div style={{flex: 1, display: 'flex', pointerEvents: 'none'}}>
                <div style={{position: 'absolute', right: 0, top: 0, bottom: 0, left: 0, zIndex: 1, background: 'rgba(255,255,255,0.5)'}}>
                  
                </div>
                <InnerComponent mount={mount} unmount={unmount} options={layout.options} />
              </div>
            </div>
          })}
        </ResponsiveReactGridLayout>
      </Box>
    </div>;
}